import styled from 'styled-components';

export const AccountInformationItemWrapper = styled.div<{ isPrint: boolean }>`
  padding: ${p => p.theme.app.padding.horizontal};

  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  gap: 12px;

  border-bottom: 1px solid ${props => (props.isPrint ? '#000000' : '#efefef')};

  &:last-child {
    border-bottom: 0px !important;
  }
`;
